import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import BlockOutlinedIcon from '@mui/icons-material/BlockOutlined';
import type { ObjectDetailsHeaderAction } from 'framework/ViewTypes/contentLayout';
import {
  EDITABLE_POSITION_FILL_REQUEST_STATUSES,
  POSITION_FILL_REQUEST_STATUS,
  type PositionFillRequestStatus,
} from '../../constants';

type PositionFillRequestHeaderActionConfig = {
  canUpdate: boolean;
  canCancel: boolean;
  onEdit: () => void;
  onCancel: () => void;
};

const CANCELLABLE_POSITION_FILL_REQUEST_STATUSES: PositionFillRequestStatus[] = [
  POSITION_FILL_REQUEST_STATUS.REQUESTED,
  POSITION_FILL_REQUEST_STATUS.PENDING,
  POSITION_FILL_REQUEST_STATUS.ACTIVE,
];

export const getPositionFillRequestHeaderActions = (
  status: PositionFillRequestStatus,
  config: PositionFillRequestHeaderActionConfig,
): ObjectDetailsHeaderAction[] => {
  const actions: ObjectDetailsHeaderAction[] = [];

  if (config.canUpdate && EDITABLE_POSITION_FILL_REQUEST_STATUSES.includes(status)) {
    actions.push({
      id: 'edit-position-fill-request',
      label: 'Edit position fill request',
      icon: <EditOutlinedIcon />,
      variant: 'outlined',
      tooltip: 'Edit position fill request',
      onClick: config.onEdit,
    });
  }

  if (config.canUpdate && CANCELLABLE_POSITION_FILL_REQUEST_STATUSES.includes(status)) {
    actions.push({
      id: 'cancel-position-fill-request',
      label: 'Cancel position fill request',
      icon: <BlockOutlinedIcon />,
      color: 'error',
      variant: 'outlined',
      tooltip: 'Cancel position fill request',
      onClick: config.onCancel,
    });
  }

  return actions;
};
